import ListItem from "@/components/ListItem/ListItem";
import { getFacilityMatchHeadline, getFacilityMatchSupportingContent } from "./matchContext";
import { FacilityHit } from "./types";

export const createFacilityOnlySearchUiState = (indexName: string) => {
  return {
    [indexName]: {
      configure: {
        filters: "object_type:Facility",
        restrictSearchableAttributes: ["facility_name", "name", "legacy_id", "section_name", "phone", "phones"],
        attributesToHighlight: ["facility_name", "name", "legacy_id", "section_name", "phone", "phones"]
      }
    }
  };
};

export const renderFacilityOnlyHit = (hit: FacilityHit, select: (hit: FacilityHit) => void, query?: string) => {
  const supportingText = getFacilityMatchSupportingContent(hit, query);
  return (
    <button key={hit.objectID} type="button" className="cursor-pointer w-full text-left" onClick={() => select(hit)}>
      <ListItem
        compact
        useAvatar
        iconName="store"
        headline={getFacilityMatchHeadline(hit)}
        supportingText={supportingText}
        longContent={!!supportingText}
      />
    </button>
  );
};

export const getFacilityDisplayName = (hit: FacilityHit): string => {
  return hit.facility_name || hit.name || "Unknown Facility";
};

export const isFacilityExactMatch = (hit: FacilityHit, query: string): boolean => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return false;
  return hit.legacy_id?.toLowerCase() === normalizedQuery;
};
